export default __webpack_public_path__ + "static/icecream-health-3-mobile-360bb97b02c40c6ef019577b7c3a25e6.png";